import { InputLabel, useTheme } from '@mui/material';
import React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const SelectInput = ({ options, value, onChange, label }) => {


    const labelId = `select-label-${label?.replace(/\s+/g, '-').toLowerCase() || 'default'}`;


    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    return (
        <div dir='rtl'>
            <FormControl sx={{
                width: '100%', mt: 3, direction: "rtl",
                "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                        borderColor: "#bdbdbd", // Default border color
                    },
                    "&.Mui-focused fieldset": {
                        borderColor: "#161D6F", // Border color when focused
                        borderWidth: 2,         // Optional: make border thicker on focus
                    }
                },
                "& label": {
                    color: "#333", // Default label color
                    fontWeight: 700,
                  },
                  "& label.Mui-focused": {
                    color: "#161D6F", // Label color when focused
                    fontWeight: 900,
                  }
            }}>
                <InputLabel
                    id={labelId}
                    shrink
                    sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        mb: '8px',
                        bgcolor: "white",
                        px: '4px',
                        textAlign: "right",
                        right: 0,
                        left: 'unset',
                        mr: '0px',
                        color: "#0C359E",
                    }}
                >
                    {label}
                </InputLabel>
                <Select
                    displayEmpty
                    value={value}
                    onChange={onChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => {
                        if (!selected) {
                            return <span style={{ fontSize: "12px", fontWeight: 500, color: "#3C3D37" }}>لطفا گزینه مورد نظر خود را انتخاب نمایید</span>
                        }
                        return selected;
                    }}
                    MenuProps={MenuProps}
                    inputProps={{ 'aria-label': 'Without label' }}
                    sx={{ fontSize: "14px", fontWeight: 700, color: "#6069E7" }}
                >
                    <MenuItem disabled value="" sx={{ fontSize: "16px" }}>
                        <span style={{ fontSize: "12px", fontWeight: 500, color: "#3C3D37" }}>لطفا گزینه مورد نظر خود را انتخاب نمایید</span>
                    </MenuItem>
                    {options.map((name) => (
                        <MenuItem key={name} value={name} sx={{ fontSize: "14px", fontWeight: 500 }}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}

export default SelectInput
